import * as authJwt from './authJwt'

export function storeToken(token, stayLoggedIn, refreshToken) {
    return authJwt.storeToken(token, stayLoggedIn, refreshToken);
}

export function getDetails() {
    return authJwt.getDetails();
}

export function getToken() {
    return authJwt.getToken();
}

export function isAuthenticated() {
    return authJwt.isAuthenticated();
}

export function deleteToken() {
    return authJwt.deleteToken();
}

export function getTokenExpirationDate(encodedToken) {
    return authJwt.getTokenExpirationDate(encodedToken);
}

export function hasExpired(token) {
    return authJwt.hasExpired(token);
}
